import React from 'react';
import PropTypes from 'prop-types';
import { ModalFooter as ReactModalFooter } from 'reactstrap';
import './modal.scss';

export const ModalFooter = ({
    align,
    children,
}) => {

    const modalFooterClasses = [
        `bsw-modal-footer`,
        `${align ? `bsw-modal-footer--align-${align}` : ''}`,
    ].join(' ');

    return (<>{children
        ? <ReactModalFooter
            className={modalFooterClasses}
        >
            {children}
        </ReactModalFooter>
        : null
    }</>
    );
}
